// extracted by mini-css-extract-plugin
export default {"login_input_wrapper":"LoginInput_login_input_wrapper__L6YAB"};